import './PaidMethod.css';

import logoImage from './../../image/logo.svg';

const PaidMethod = () => {
    return (
        <div className='paid_method__wrapper'>
            <div className='paid_method__logo'>
                <img src={logoImage} alt='Logo' />
            </div>
            <div className='paid_method__main'>
                <div className='paid_method__info'>
                    <h3 className='paid_method__title'>
                        Выберите способ оплаты
                    </h3>
                    <div className='paid_method__btns'>
                        <button className='paid_method__btn'>Сервис 1</button>
                        <button className='paid_method__btn'>Сервис 2</button>
                        <button className='paid_method__btn'>Сервис 3</button>
                    </div>
                </div>

                <div className='paid_method__btns'>
                    <button className='paid_method__btn'>
                        Запомнить выбор
                    </button>
                    <button className='paid_method__done'>Продолжить</button>
                </div>
            </div>
        </div>
    );
};

export default PaidMethod;
